import gsap from 'gsap';
import { ease1 } from '../../easings';

const ANIMATION_SELECTORS = {
    HEADER: {
        TITLE: '.js-news-title',
        TAG: '.js-news-tag',
        SORT: '.js-content-filters-sort',
        BREADCRUMBS: 'a-breadcrumbs',
        BREADCRUMB: '.a-breadcrumbs__item',
        TAGS_LIST: '.js-filter-tags-list',
    },
    POSTS_CONTAINER: '.js-news-list',
};

const init = () => {
    const firstViewportTimeline = gsap.timeline({ defaults: { duration: 1, ease: ease1 } });

    firstViewportTimeline
        .set(ANIMATION_SELECTORS.HEADER.BREADCRUMBS, { opacity: 1 })
        .set(ANIMATION_SELECTORS.HEADER.TAGS_LIST, { opacity: 1 })
        .fromTo(
            ANIMATION_SELECTORS.HEADER.TITLE,
            { yPercent: 80, opacity: 0 },
            { duration: 1.3, yPercent: 0, opacity: 1 },
        )
        .fromTo(
            ANIMATION_SELECTORS.HEADER.TAG,
            { opacity: 0 },
            {
                duration: 1.4,
                opacity: 1,
                delay: -0.8,
                stagger: 0.13,
                onStart: () => {
                    setTimeout(() => {
                        gsap.to(ANIMATION_SELECTORS.POSTS_CONTAINER, {
                            duration: 1.5,
                            opacity: 1,
                        });
                    }, 800);
                },
            },
        )
        .fromTo(
            ANIMATION_SELECTORS.HEADER.BREADCRUMB,
            { opacity: 0 },
            { duration: 1.4, opacity: 1, delay: -0.8, stagger: 0.17 },
        )
        .to(ANIMATION_SELECTORS.HEADER.SORT, {
            duration: 1.4,
            opacity: 1,
            delay: -1.6,
        });
};

const _module = { init };

export default _module;
